/**
 * Component for displaying Noun Project icons.
 * Provides a consistent way to use Noun Project icons throughout the app.
 */

import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface NounProjectIconProps {
  iconName: string;
  size?: number;
  color?: string;
  sx?: SxProps<Theme>;
}

const NounProjectIcon: React.FC<NounProjectIconProps> = ({
  iconName,
  size = 24,
  color,
  sx,
}) => {
  const iconPath = `/icons/${iconName}.png`;
  
  return (
    <Box
      component="img"
      src={iconPath}
      alt={iconName}
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        filter: color ? `brightness(0) saturate(100%) ${color}` : undefined,
        ...sx,
      }}
    />
  );
};

export default NounProjectIcon;



